var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "step",
    {
      attrs: {
        title: _vm.title,
        id: "alternate-compare",
        description: _vm.description,
        component: _vm.component,
        icon: "mdi mdi-compare-horizontal",
        optional: _vm.optional,
      },
    },
    [
      _c(
        "div",
        { staticClass: "flex-grow flex flex-col pb-4" },
        [
          _c(
            "toolbar",
            [
              _c("div", { staticClass: "flex-grow" }),
              _vm._v(" "),
              _vm.packages.length > 0
                ? _c(
                    "field",
                    {
                      staticClass: "mr-3",
                      attrs: { disabled: _vm.packages.length === 1 },
                    },
                    [
                      _c("dropdown-field", {
                        attrs: {
                          source: _vm.packages,
                          "text-field": "packageName",
                          "value-field": "id",
                          placeholder: "Select Package...",
                        },
                        model: {
                          value: _vm.innerPackageId,
                          callback: function ($$v) {
                            _vm.innerPackageId = $$v
                          },
                          expression: "innerPackageId",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex flex-row my-2" },
                [
                  _c(
                    "btn",
                    {
                      staticClass: "rounded-r-none",
                      on: {
                        click: function ($event) {
                          return _vm.gotoSurvivorship(true)
                        },
                      },
                    },
                    [_vm._v("Go To Targeted Survivorship")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-menu",
                    {
                      attrs: { width: 300, "suppress-toggle-on-click": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "toggle",
                          fn: function () {
                            return [
                              _c(
                                "btn",
                                {
                                  staticClass: "rounded-l-none",
                                  on: {
                                    click: function ($event) {
                                      _vm.showMenu = !_vm.showMenu
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "mdi mdi-menu-down" })]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.showMenu,
                        callback: function ($$v) {
                          _vm.showMenu = $$v
                        },
                        expression: "showMenu",
                      },
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "menu-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.gotoSurvivorship()
                            },
                          },
                        },
                        [_vm._v("Go To Full Survivorship")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("compare", {
            key: `compare-${_vm.innerPackageId}`,
            staticClass: "flex-grow my-4",
            attrs: {
              leftDisplayName: "Golden",
              rightDisplayName: _vm.alternate,
              compareEndpoint: _vm.compareEndpoint,
              compareUploadedFiles: true,
              scratchApiRoot: _vm.parsedLsUrl,
              onExport: _vm.onExport,
              lsProps: _vm.lsProps,
              isNew: true,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }